import { inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import { RouteConstants } from '../../../../../core/constants/routes';

/**
 * Coordination routes that cannot be directly navigated to outside of the application flow.
 */
const RESTRICTED_PATHS = [
    RouteConstants.Application.coordinationResults.replace(':id', ''),
];

export const ApplicationCoordinationInitializerResolver = (
    // Even though `route` isn't directly referenced, it is necessary for the full URL to be captured
    // by state.url. Do not remove this.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
) => {
    const router = inject(Router);
    const url = state.url;

    if (RESTRICTED_PATHS.find((restricted) => url.includes(restricted))) {
        console.log(`Unable to navigate to '${url}' directly.`);

        router.navigate(['/']);

        return;
    }
};
